import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotificationFilter } from '../notification-viewer.component';

@Component({
  selector: 'vfs-notification-viewer-bar',
  templateUrl: './notification-viewer-bar.component.html',
  styleUrls: ['./notification-viewer-bar.component.scss']
})
export class NotificationViewerBarComponent implements OnInit {
  @Input() disabled: boolean;
  @Output() selected = new EventEmitter<NotificationFilter>();

  unread = true;
  important = true;
  error = true;
  flagged = true;

  constructor() {}

  ngOnInit(): void {}

  onChange(): void {
    this.selected.emit({
      unread: this.unread,
      important: this.important,
      error: this.error,
      flagged: this.flagged
    });
  }
}
